module.exports = __webpack_public_path__ + "img/Logo_de_Rue89_Bordeaux.72cae11f.png";